export default "__VITE_ASSET__D6T8iA$s__"